import { supabase } from '../supabaseClient.js';
import toast from 'react-hot-toast';

export async function decrementStockById(id) {
  try {
    const { data, error: fetchError } = await supabase
      .from('figurines')
      .select('stock')
      .eq('id', id)
      .single();

    if (fetchError || !data) {
      console.error('Fetch error:', fetchError);
      return false;
    }

    const { error: updateError } = await supabase
      .from('figurines')
      .update({ stock: Math.max(data.stock - 1,0) })
      .eq('id', id);

    if (updateError) {
      console.error('Update error:', updateError);
      return false;
    }
    if (data.stock-1 === 0) {
      toast.error("⚠️ No more stock left!");
    }
    return true;
  } catch (err) {
    console.error('Unexpected error:', err);
    return false;
  }
}

export async function incrementStockById(id) {
  try {
    // Step 1: Fetch the current stock
    const { data, error: fetchError } = await supabase
      .from('figurines')
      .select('stock')
      .eq('id', id)
      .single();

    if (fetchError || !data) {
      console.error('Fetch error:', fetchError);
      return false;
    }

    // Step 2: Update the stock
    const { error: updateError } = await supabase
      .from('figurines')
      .update({ stock: data.stock + 1 })
      .eq('id', id);

    if (updateError) {
      console.error('Update error:', updateError);
      return false;
    }

    return true;
  } catch (err) {
    console.error('Unexpected error:', err);
    return false;
  }
}

  

  export function validateAdminPassword(password) {
    return password === process.env.REACT_APP_ADMIN_PASSWORD;
  }
  
